// Exclude from page generation
export const excludedRoutes = [];

// Generate page, exclude from sitemap
export const excludedSitemap = [/\/preview(\/)?$/, /\/not-found(\/)?$/, /\/404(\/)?$/];

export default {
  home_page: {
    "de-de": "/de/",
    "en-de": "/en/",
  },
};
